import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { Check } from 'lucide-react';
import WhatsAppCTA from '../components/WhatsAppCTA';

const UltimateDetail = () => {
  return (
    <div className="min-h-screen bg-black">
      <Helmet>
        <title>Ultimate Detail from €280 Kerry | Premium Car Detailing | Kingdom Auto Detailing</title>
        <meta name="description" content="Ultimate car detail from €280 in Kerry. Complete transformation including engine bay, clay bar treatment, gloss polish, roof lining and seatbelt cleaning. Book now!" />
        <meta name="keywords" content="ultimate car detail Kerry, premium car detailing, engine bay cleaning Kerry, clay bar treatment Ireland, gloss enhancement polish, best car valet Kerry" />
        <link rel="canonical" href="https://kingdomautodetailing.ie/ultimate-detail" />
      </Helmet>

      <section className="relative h-[400px] bg-cover bg-center" style={{ backgroundImage: 'url(https://images.unsplash.com/photo-1601362840469-51e4d8d58785?w=1200&q=80)' }}>
        <div className="absolute inset-0 bg-black/60"></div>
        <div className="relative h-full flex flex-col items-center justify-center text-center px-4">
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">ULTIMATE DETAIL</h1>
          <Link to="/booking" className="bg-amber-500 hover:bg-amber-600 text-zinc-900 font-bold px-8 py-4 rounded-lg transition-colors text-lg">BOOK NOW</Link>
        </div>
      </section>
      <section className="py-16 px-4 bg-zinc-900">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl font-bold text-white mb-6">SERVICE DESCRIPTION</h2>
          <p className="text-gray-300 text-lg mb-8 leading-relaxed">The ultimate service to transform your vehicle into something truly special! Our Ultimate Detail covers every aspect, including deep cleaning of the interior (roof lining and seat belts), exterior (clay treatment and gloss enhancement polish), and engine bay detailing.</p>
          <div className="grid md:grid-cols-2 gap-8">
            <div className="bg-black rounded-2xl p-6">
              <h3 className="text-2xl font-bold text-amber-500 mb-4">Exterior</h3>
              <ul className="space-y-3">
                {['Our Full Detail package - Exterior', '+ Engine bay detail', '+ Clay bar treatment', '+ Gloss enhancement polish (non-correctional)', '+ 6 weeks wax applied'].map((item, idx) => <li key={idx} className="flex items-start space-x-2 text-gray-300"><Check className="text-amber-500 mt-1 flex-shrink-0" size={20} /><span>{item}</span></li>)}
              </ul>
            </div>
            <div className="bg-black rounded-2xl p-6">
              <h3 className="text-2xl font-bold text-amber-500 mb-4">Interior</h3>
              <ul className="space-y-3">
                {['Our Full Detail package - Interior', '+ Roof lining cleaned', '+ Seat belts cleaned'].map((item, idx) => <li key={idx} className="flex items-start space-x-2 text-gray-300"><Check className="text-amber-500 mt-1 flex-shrink-0" size={20} /><span>{item}</span></li>)}
              </ul>
            </div>
          </div>
        </div>
      </section>
      <section className="py-16 px-4 bg-black">
        <div className="max-w-4xl mx-auto text-center">
          <div className="bg-gradient-to-br from-blue-600 to-blue-700 rounded-3xl p-8">
            <h2 className="text-4xl font-bold text-white mb-4">Ultimate Detail Pricing</h2>
            <p className="text-2xl text-blue-100 mb-4">Prices from</p>
            <p className="text-6xl font-bold text-white mb-6">€280</p>
            <Link to="/booking" className="inline-block bg-white hover:bg-gray-100 text-blue-600 font-bold px-8 py-4 rounded-lg transition-colors text-lg">Book Your Ultimate Detail</Link>
          </div>
        </div>
      </section>
      <section className="py-16 px-4 bg-zinc-900">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-4xl font-bold text-white mb-12 text-center">Frequently Asked Questions</h2>
          <div className="space-y-6">
            {[{question: 'What is the difference between this and Full Detail package?', answer: 'The Ultimate Detail includes clay bar treatment and gloss enhancement polish, which significantly improve gloss, paint smoothness, and clarity. Additionally, it features comprehensive engine bay cleaning, restoring it to factory condition. Interior extras include roof lining and seat belt cleaning, ensuring every aspect of your vehicle receives attention and making it feel truly personalized.'}, {question: 'What are the benefits of this package?', answer: 'The benefit lies in the complete transformation of your vehicle. With comprehensive deep cleaning throughout, your car will feel as if it just left the factory, providing a fresh start and a truly personalized ownership experience.'}, {question: 'How long does the Ultimate Detail take?', answer: 'The Ultimate Detail typically takes 5-6 hours, with duration varying based on your vehicle size and condition.'}, {question: 'Will the gloss enhancement polish remove scratches?', answer: 'No, the gloss enhancement polish will not remove scratches or swirl marks. Its purpose is to enhance gloss, clarity, and smoothness of your paintwork, restoring the factory finish appearance without paint correction.'}].map((faq, idx) => <div key={idx} className="bg-black rounded-2xl p-6"><h3 className="text-xl font-bold text-amber-500 mb-3">{faq.question}</h3><p className="text-gray-300 leading-relaxed">{faq.answer}</p></div>)}
          </div>
        </div>
      </section>
      <section className="py-16 px-4 bg-black">
        <div className="max-w-4xl mx-auto">
          <div className="bg-zinc-900 rounded-2xl p-8 text-center">
            <h2 className="text-2xl font-bold text-white mb-4">CANCELLATION POLICY</h2>
            <p className="text-gray-300 text-lg">To cancel or reschedule, please contact us 1-2 days in advance to avoid forfeiting your €25 deposit fee</p>
          </div>
        </div>
      </section>

      {/* WhatsApp CTA */}
      <WhatsAppCTA />
    </div>
  );
};

export default UltimateDetail;